import hydrate from 'widget/hydrate';
import PlaylistRadio from './PlaylistRadio';
import { ComponentProps, ComponentType } from 'react';

hydrate<ComponentProps<ComponentType<any>>>(PlaylistRadio);
